// fader
fadeInPage();

function fadeInPage() {
  if (!window.AnimationEvent) {
    return;
  }
  var fader = document.getElementById("fader");
  fader.classList.add("fade-out");
}

document.addEventListener("DOMContentLoaded", function () {
  if (!window.AnimationEvent) {
    return;
  }
  var anchors = document.getElementsByTagName("a");

  for (var idx = 0; idx < anchors.length; idx += 1) {
    if (
      anchors[idx].hostname !== window.location.hostname ||
      anchors[idx].pathname === window.location.pathname
    ) {
      continue;
    }
    anchors[idx].addEventListener("click", function (event) {
      var fader = document.getElementById("fader"),
        anchor = event.currentTarget;

      var listener = function () {
        window.location = anchor.href;
        fader.removeEventListener("animationend", listener);
      };
      fader.addEventListener("animationend", listener);

      event.preventDefault();
      fader.classList.add("fade-in");
    });
  }
});
window.addEventListener("pageshow", function (event) {
  if (!event.persisted) {
    return;
  }
  var fader = document.getElementById("fader");
  fader.classList.remove("fade-in");
});

// main margin
$(function () {
  var headerHeight = $(".menu").outerHeight();
  $("main").css("marginTop", headerHeight);
});

// mini-cart
$(document).ready(function () {
  (onVariantRadioChange = function (event) {
    let $radio = $(this),
      $form = $radio.closest("form"),
      max = $radio.attr("data-inventory-quantity"),
      $addToCartButton = $form.find("#add-to-cart-button");
  }),
    (onAddToCart = function (event) {
      event.preventDefault();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $(this).serialize(),
        dataType: "json",
        success: onCartUpdated,
        error: onError,
      });
    }),
    (onLineRemoved = function (event) {
      event.preventDefault();

      let $removeLink = $(this),
        removeQuery = $removeLink.attr("href").split("change?")[1];
      $.post("/cart/change.js", removeQuery, onCartUpdated, "json");
    }),
    (onCartUpdated = function () {
      $.ajax({
        type: "GET",
        url: "/cart",
        context: document.body,
        success: function (context) {
          let $dataCartContents = $(context).find(".js-cart-page-contents"),
            dataCartHtml = $dataCartContents.html(),
            dataCartItemCount = $dataCartContents.attr("data-cart-item-count"),
            dataCartItemTotal = $dataCartContents.attr("data-cart-item-total"),
            $miniCartContents = $(".js-mini-cart-contents"),
            $cartItemCount = $(".js-cart-item-count");
          $cartItemTotal = $(".js-cart-item-total");

          $cartItemCount.text(dataCartItemCount);
          $cartItemTotal.text(dataCartItemTotal);
          $miniCartContents.html(dataCartHtml);

          if (parseInt(dataCartItemCount) > 0) {
            openCart();

            setTimeout(function () {
              closeCart();
            }, 6000);
          } else {
            setTimeout(function () {
              closeCart();
            }, 2000);
          }
        },
      });
    }),
    (onError = function (XMLHttpRequest, textStatus) {
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + " - " + data.message + ": " + data.description);
    }),
    (openCart = function () {
      $("html").addClass("mini-cart-open");
      $("#mini-cart").addClass("visible");
    }),
    (closeCart = function () {
      $("html").removeClass("mini-cart-open");
      $("#mini-cart").removeClass("visible");
    }),
    (onCartButtonClick = function (event) {
      event.preventDefault();

      let isCartOpen = $("html").hasClass("mini-cart-open");

      if (!isCartOpen) {
        openCart();
      } else {
        closeCart();
      }
    });

  $(document).on("change", ".js-variant-radio", onVariantRadioChange);
  $(document).on("submit", "#add-to-cart-form, #add-to-cart-mobile", onAddToCart);
  $(document).on("click", "#mini-cart .js-remove-line", onLineRemoved);
  $(document).on(
    "click",
    ".js-cart-link, #mini-cart .js-keep-shopping",
    onCartButtonClick
  );
});

// menu
function desktopMenu() {
  $(".menu > ul > li .menu-main").on("click", function () {
    if ($(window).width() > 960) {
      // $(this).toggleClass("active-menu");
      $("#mini-cart").removeClass("visible");

      $("body").addClass("locked");
      $(this)
        .parent()
        .addClass("menu-active")
        .siblings()
        .removeClass("menu-active");

      $(".menu > ul > li")
        .children("ul")
        .stop(true, false)
        .delay(200)
        .fadeOut(300);
      $(this).parent().children("ul").stop(true, false).fadeIn(300);
      e.preventDefault();
    }
  });

  $(".menu-container").mouseleave(function () {
    if ($(window).width() > 960) {
      $("body").removeClass("locked");

      $(this).find(".menu > ul > li").removeClass("menu-active");

      $(this)
        .find(".menu > ul > li > ul")
        .stop(true, false)
        .delay(200)
        .fadeOut(300);
      e.preventDefault();
    }
  });

  // mobile click
  $(".menu > ul > li").click(function () {
    if ($(window).width() <= 960) {
      $(".menu > ul > li")
        .not($(this))
        .children("ul")
        .stop(true, false)
        .delay(100)
        .slideUp(600);
      $(this).children("ul").delay(100).stop(true, false).slideToggle(600);
      $(".menu > ul > li").not(this).removeClass("active-menu-mobile");
      $(this).toggleClass("active-menu-mobile");
      e.preventDefault();
    }
  });

  $(".cart-mobile_trigger").click(function (e) {
    $("body").addClass("locked");
    $(".menu > ul").addClass("show-on-mobile");
    $(".cart-header").hide();
    $(".menu-close").fadeIn(300);
    $(".menu > ul > li > ul")
      .first()
      .stop(true, false)
      .delay(800)
      .slideDown(600)
      .parent()
      .addClass("active-menu-mobile");
    e.preventDefault();
  });

  $(".menu-close").click(function (e) {
    $("body").removeClass("locked");
    $(".menu > ul > li")
      .removeClass("active-menu-mobile")
      .children("ul")
      .stop(true, false)
      .delay(400)
      .slideUp();
    $(".menu > ul").removeClass("show-on-mobile");
    $(".cart-header").fadeIn(300);
    $(".menu-close").hide();
    e.preventDefault();
  });
}

$(function () {
  desktopMenu();
  $(window).on("resize", function () {
    desktopMenu();
  });
});

// pdp form
$(function () {
  $(
    ".pdp-form input:not([disabled]):first, .pdp-form-mobile input:not([disabled]):first"
  ).prop("checked", true);
});

// total collection items
$(function () {
  $(".collection-item").each(function (index) {
    var collectionTotal = $(this).find(".collection-item_gallery img").length;
    $(".collection-total", this).text(("0" + collectionTotal).slice(-2));
  });
});

// collection image proportion
setTimeout(function () {
  $(".slider-collection .swiper-slide img").each(function () {
    var $this = $(this);
    if ($this.width() < $this.height()) {
      $this.addClass("w-50");
    }
  });
}, 200);

// collections page hover
$(".collection-item").on("mouseenter", function () {
  $(".collection-item")
    .not($(this))
    .find(".collection-item_header, .collection-item_gallery-img span")
    .css("opacity", 0);
});

$(".collection-item").on("mouseleave", function () {
  $(".collection-item")
    .find(".collection-item_header, .collection-item_gallery-img span")
    .css("opacity", 1);
});

// pdp accordion
$(function () {
  $(".acc-toggler").on("click", function (e) {
    $(this).toggleClass("open-toggler");
    $(".acc-toggler").not(this).removeClass("open-toggler");

    var accContent = $(this).next(".acc-content");
    var accPlus = $(this).find(".acc-plus");

    $(".acc-content").not(accContent).slideUp();
    accContent.slideToggle().addClass("is-open");
    $(".acc-content").not(accContent).removeClass("is-open");
  });

  // add hash
  $(".care .acc-toggler").click(function (e) {
    window.location.hash = $(this).data("hashtag");
    e.preventDefault();
  });

  if (window.location.hash) {
    var currentHash = window.location.hash;
    var currentHashClean = currentHash.substring(1, currentHash.length);
    var currentAccordion = $(".acc-content." + currentHashClean + "");
    currentAccordion.slideDown().css("display", "block");
    currentAccordion.prev(".acc-toggler").addClass("open-toggler");

    return false;
  }
});

// menu animation
let resizeTimer;
window.addEventListener("resize", () => {
  $(".menu > ul").addClass("resize-animation-stopper");
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    $(".menu > ul").removeClass("resize-animation-stopper");
  }, 400);
});

// pdp
function adjustHeight() {
  if ($(window).width() >= 960) {
    var cWidth = $(window).width() / 4;
    var cHeight = $(window).height() / 2 - 40;
    var infoWidth = $(".pdp-info").width() / 2;
    var infoHeight = $(".pdp-info").height() / 2;
    var pWidth = cWidth - infoWidth;
    var pHeight = cHeight - infoHeight;

    $(".pdp-info").css({
      top: pHeight,
      // left: pWidth,
    });
  }
}

$(function () {
  adjustHeight();
  $(window).on("resize", function () {
    adjustHeight();
  });
});

// product popup
function productPopup() {
  if ($(window).width() <= 960) {
    $("body").on("click", ".product-trigger", function () {
      $(".product-popup").show();
      $(".product-trigger").hide();
      $("#collectionCursor").css("marginRight", 0);
    });
  } else {
    $(".product-trigger").on("mouseenter", function () {
      $(".product-popup").show();
    });

    $(".product-trigger").on("mouseleave", function () {
      $(".product-popup").hide();
    });
  }
}

$(function () {
  productPopup();
  $(window).on("resize", function () {
    productPopup();
  });
});

// change select size text
$(function () {
  $(".multi-size").click(function () {
    $(".multi-size svg").toggleClass("turn-arrow");
  });
  $(".option-fieldset > div").click(function () {
    if ($(this).find("input").is(":checked")) {
      var currentSelection = $(this).find("label").text();
      $(".current-size").text(currentSelection);
    }
    $(".pdp-form .acc-content").slideUp().removeClass("is-open");
    // $(".mobile-sizes").removeClass("is-open");
    $(".multi-size svg").removeClass("turn-arrow");
  });
});

$(".filter-list").on("submit", function (e) {
  e.preventDefault();
  $(".collection-filter").removeClass("visible");

  // Build Shopify filter URL parameters
  let filterParams = [];
  let filterActive = [];

  // Get all checked filter inputs
  $(".filter-list input:checked").each(function () {
    let $input = $(this);
    let filterValue = $input.val();
    let filterName = $input.attr("name");

    // Use the Shopify-generated parameter name directly
    if (filterName && filterValue) {
      filterParams.push(filterName + "=" + encodeURIComponent(filterValue));
      filterActive.push(
        '<span class="filter-active filter-' +
          filterValue.replace(/\s+/g, "-") +
          '">' +
          filterValue +
          "</span>"
      );
    }
  });

  // Update the filters-active display
  $(".filters-active").html(filterActive);

  // Build the new URL
  let currentUrl = new URL(window.location);

  // Remove existing filter parameters
  for (let key of currentUrl.searchParams.keys()) {
    if (key.startsWith("filter.")) {
      currentUrl.searchParams.delete(key);
    }
  }

  // Add new filter parameters
  filterParams.forEach(function (param) {
    let [key, value] = param.split("=");
    currentUrl.searchParams.set(key, decodeURIComponent(value));
  });

  // Navigate to the filtered URL
  window.location.href = currentUrl.toString();
});

// sortby
function sortMeBy(arg, sel, elem, order) {
  var $selector = $(sel),
    $element = $selector.children(elem);

  $element.sort(function (a, b) {
    var an = parseInt(a.getAttribute(arg)),
      bn = parseInt(b.getAttribute(arg));

    if (order == "asc") {
      if (an > bn) return 1;
      if (an < bn) return -1;
    } else if (order == "desc") {
      if (an < bn) return 1;
      if (an > bn) return -1;
    }
    return 0;
  });

  $element.detach().appendTo($selector);
}

$('.sort-list input[type="radio"]').on("change", function () {
  // Don't auto-submit - let user click Apply button
  // Just update the visual state
});

$(".sort-list").on("submit", function () {
  $(".collection-sort").removeClass("visible");
  // Let the form submit normally to the server
  return true;
});

// featured box
$(function () {
  $(".featured-box img").on("mouseover", function () {
    $(".featured-menu a span").addClass("hovered");
  });

  $(".featured-box img").on("mouseleave", function () {
    $(".featured-menu a span").removeClass("hovered");
  }),
    $(".archive-box img").on("mouseover", function () {
      $(".archive-box a span").addClass("hovered");
    });

  $(".archive-box img").on("mouseleave", function () {
    $(".archive-box a span").removeClass("hovered");
  });
});

// featured block
const swiper = new Swiper(".swiper", {
  // Optional parameters
  direction: "horizontal",
  mousewheel: {
    forceToAxis: true,
  },
  slidesPerView: 1.5,
  spaceBetween: 70,
  speed: 2000,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },

  breakpoints: {
    512: {
      spaceBetween: 100,
      slidesPerView: 1.5,
      freeMode: {
        enabled: true,
        sticky: true,
      },
    },
    960: {
      spaceBetween: 100,
      slidesPerView: 2.5,
      freeMode: {
        enabled: true,
        sticky: true,
      },
    },
  },
});

// plp slider
const swiperPLP = new Swiper(".plp-slider", {
  // Optional parameters
  direction: "horizontal",
  loop: true,
  speed: 300,
  allowTouchMove: false,

  breakpoints: {
    512: {
      speed: 0,
    },
  },

  // Navigation arrows
  navigation: {
    nextEl: ".plp-slider-next",
    prevEl: ".plp-slider-prev",
  },
});

// materials mobile
const materials = new Swiper(".materials-mobile", {
  // Optional parameters
  direction: "horizontal",
  slidesPerView: "auto",
  autoHeight: true,
  speed: 300,
  loop: false,
  watchOverflow: true,
});

// collection slider
const collection = new Swiper(".slider-collection", {
  // Optional parameters
  direction: "horizontal",
  slidesPerView: 1,
  loop: true,
  speed: 300,
  allowTouchMove: true,

  breakpoints: {
    960: {
      speed: 0,
      allowTouchMove: false,
    },
  },

  navigation: {
    nextEl: ".slider-collection .swiper-slide, #collectionCursor",
  },

  // If we need pagination
  pagination: {
    el: ".paginate",
    type: "custom",
    renderCustom: function (collection, current, total) {
      return (
        ("0" + current).slice(-2) + " \xa0\xa0\xa0/" + ("0" + total).slice(-2)
      );
    },
  },
});

// collection cursor
$(function () {
  var ElementCursor = {
    cursorElement: "",
    setCursor: function (cursorId) {
      $(".slider-collection").css({
        cursor: "none",
      });
      $(".slider-collection").mousedown(function (e) {
        return false;
      });
      ElementCursor.cursorElement = cursorId;
      ElementCursor.updateCursor();
    },
    removeCursor: function () {
      $(".slider-collection").css({
        cursor: "",
      });
      ElementCursor.cursorElement = "";
    },
    updateCursor: function () {
      $(".slider-collection").mousemove(function (e) {
        $("#" + ElementCursor.cursorElement).css({
          position: "fixed",
          top: e.pageY + "px",
          left: e.pageX + "px",
        });
      });
    },
  };

  ElementCursor.setCursor("collectionCursor");
});

// hide cursor collection
if ($(window).width() >= 960) {
  $(window).scroll(function () {
    if ($(window).scrollTop() > $(".slider-collection").height() / 4) {
      $("#collectionCursor").fadeOut(300);
    } else {
      $("#collectionCursor").fadeIn(300);
    }
  });
}

// collection image thumb
$(function () {
  $(".slider-collection .swiper-slide-next img:first-child")
    .clone()
    .appendTo("#collectionCursor");
});

$(".slider-collection .swiper-slide, #collectionCursor").on(
  "click",
  function () {
    var activeImg = $(
      ".slider-collection .swiper-slide-next img:first-child"
    ).attr("src");
    $("#collectionCursor img").attr("src", activeImg);
    $(".product-popup").hide();
    $(".product-trigger").show();
    $("#collectionCursor").css("marginRight", "4rem");
  }
);

// plp hover
$(function () {
  $(".plp .plp-block").each(function () {
    $(".plp .plp-item").on("mouseenter", function () {
      var title = $(this).data("title");
      var price = $(this).data("price");
      $(this).parents(".plp-block").find(".plp-title").show().html(title);
      $(this).parents(".plp-block").find(".plp-price").show().html(price);
    });
    $(".plp .plp-item").on("mouseleave", function () {
      $(".plp-title").hide();
      $(".plp-price").hide();
    });
  });
});

// Initialize active filters display on page load
$(document).ready(function () {
  initializeActiveFilters();
});

function initializeActiveFilters() {
  let currentUrl = new URL(window.location);
  let filterActive = [];

  // Check for filter parameters in URL
  for (let [key, value] of currentUrl.searchParams.entries()) {
    if (key.startsWith("filter.")) {
      let filterValue = decodeURIComponent(value);
      filterActive.push(
        '<span class="filter-active filter-' +
          filterValue.replace(/\s+/g, "-") +
          '">' +
          filterValue +
          "</span>"
      );
    }
  }

  // Update the filters-active display
  if (filterActive.length > 0) {
    $(".filters-active").html(filterActive);
  }
}

// collection filter
$(".filter-trigger").on("click", function () {
  $("#mini-cart").removeClass("visible");

  $(".collection-filter").addClass("visible");

  return false;
});

$(".filter-close").on("click", function () {
  $(".collection-filter").removeClass("visible");
});

// Filter form submission is now handled by the main filter-list submit handler above

// collection sort
$(".sort-trigger").on("click", function () {
  $("#mini-cart").removeClass("visible");

  $(".collection-sort").addClass("visible");

  return false;
});

$(".sort-close").on("click", function () {
  $(".collection-sort").removeClass("visible");
});

// mini-cart
$(".cart-trigger").on("click", function () {
  $("#mini-cart").addClass("visible");

  return false;
});

$(".cart-close").on("click", function () {
  $("#mini-cart").removeClass("visible");
});

// newsletter popup
$(document).ready(function () {
  $(".newsletter-close").click(function () {
    $(".newsletter-popup").removeClass("visible");

    if (!$(".newsletter-popup").is()) {
      // Add the cookie. It will remain for a month
      Cookies.set("popup", 1, { expires: 30, path: "/" });
    }
    return false;
  });

  // If the cookie is true, don't show the cookie bar
  if (!Cookies.get("popup") == 1) {
    setTimeout(function () {
      $(".newsletter-popup").addClass("visible");
    }, 3000);
  }
});
